import { api } from "./api";
import { newIndication } from "./realization.service";
import { atualizarIniciativa } from "./iniciativa-elbb.service";
import { TeamData } from "types/realization";
import { dedupParticipantes } from "utils/participantes-dedup";

export { atualizarIniciativa };

export const buscarDetalhesMembros = async (memberIds: string[]): Promise<TeamData[]> => {
  try {
    if (!memberIds || memberIds.length === 0) return [];

    const { data } = await api.post('/find/bb_players_by_ids', { memberIds });

    if (!Array.isArray(data)) return [];
    return data;
  } catch (error) {
    console.error('Erro ao buscar detalhes dos membros:', error);
    return [];
  }
};

export const inscricaoIniciativaPremio = async (
  body: any,
  iniciativaOriginal: any,
  selectedParticipants: TeamData[],
  allTeamData?: TeamData[]
): Promise<any> => {
  try {
    body['id_realizacao'] = iniciativaOriginal._id;
    const { data } = await api.post('/database/inscricao__c', body);

    if (!data) throw new Error('Falha ao criar inscrição');

    const participantsForIndication = selectedParticipants.length > 0
      ? selectedParticipants
      : (allTeamData || []).slice(0, 5);

    const concorrentes_info = participantsForIndication.map((p) => ({
      player: p._id,
      nome: p.nome,
      chave: p.chave,
    }));

    // Cria registro do owner
    await newIndication({
      player: body.rawPlayer,
      id_inscricao: data._id,
      id_realizacao: iniciativaOriginal._id,
      dt_aceite: new Date(),
      rawPlayer: body.rawPlayer,
      concorrentes_info,
    });

    // Bulk para demais membros do time
    const teamMembers = dedupParticipantes(iniciativaOriginal.team || allTeamData);
    if (teamMembers.length > 0) {
      api.post(
        '/database/insc_partic_premio__c/bulk',
        teamMembers
          .filter((item: any) => item._id !== body.rawPlayer)
          .map((item: any) => ({
            player: item._id,
            rawPlayer: item.chave || item.code,
            id_inscricao: data._id,
            id_realizacao: iniciativaOriginal._id,
            concorrentes_info: [],
          }))
      );
    }

    return data;
  } catch (error: any) {
    console.error('Erro ao criar inscrição Premio:', error.message);
    throw error;
  }
};
